
exports.CORSBus = {
  install (Vue) {
    const cancelsMap = new WeakMap()

    Object.defineProperty(Vue.prototype, '$cbus', {
      get () {
        return this.$root.$options.cbus
      }
    })

    Vue.mixin({
      beforeCreate () {
        const cancels = []
        cancelsMap.set(this, cancels)
        const cbusControl = this.$options.cbusControl
        if (cbusControl) {
          Object.entries(cbusControl).forEach(([key, fn]) => {
            const method = this.$options.methods[key]
            if (!method) throw new Error(`cbus control "${key}" bind not found`)
            const cancel = this.$cbus.request.control(key, method.bind(this))
            cancels.push(cancel)
          })
        }

        const cbusListen = this.$options.cbusListen
        if (cbusListen) {
          Object.entries(cbusListen).forEach(([key, fn]) => {
            const method = this.$options.methods[key]
            if (!method) throw new Error(`cbus listen "${key}" bind not found`)
            const cancel = this.$cbus.broadcast.listen(key, method.bind(this))
            cancels.push(cancel)
          })
        }
      },

      beforeDestroy () {
        const cancels = cancelsMap.get(this)
        cancels.forEach((cancel) => {
          cancel()
        })
      }
    })
  }
}